module.exports = __webpack_public_path__ + "img/flag.20eca839.svg";